import React, { FC } from 'react'

import { YOLOFlagIcon } from '@Components/Icons/YOLOFlagIcon'

import styles from './PhonePrefixItem.module.scss'

interface PhonePrefixProp{
  countryCode: string
}
export interface PhonePrefixItemProps{
  prefix?: PhonePrefixProp
  title: string
}

export const PhonePrefixItem: FC<PhonePrefixItemProps> = ({ prefix, title }) => {
  if (!prefix) {
    return null
  }
  return (
    <div className={styles.phonePrefixItem}>
      <YOLOFlagIcon country={prefix.countryCode.replace('/', '-')} />
      <p>{title}</p>
    </div>
  )
}
